import { render, staticRenderFns } from "./AmenitiesCreateModal.vue?vue&type=template&id=3a8e9170&"
import script from "./AmenitiesCreateModal.vue?vue&type=script&lang=js&"
export * from "./AmenitiesCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports